import {makeAutoObservable, observable, when} from 'mobx';

import {ReactionDisposeManager} from './ReactionDisposeManager';

export interface RequireInitialLoad {
  initialLoad: InitialLoadManager;
}

export class InitialLoadManager {
  private _done = false;
  private disposer = new ReactionDisposeManager();

  constructor() {
    makeAutoObservable<InitialLoadManager, '_done'>(
      this,
      {
        _done: observable,
      },
      {
        autoBind: true,
      },
    );
  }

  get isDone() {
    return this._done;
  }

  get isLoading() {
    return !this._done;
  }

  doneWhen(predicate: () => boolean) {
    this.disposer.watch(
      InitialLoadManager.DONE_KEY,
      when(predicate, () => {
        this._done = true;
        this.disposer.dispose(InitialLoadManager.DONE_KEY);
      }),
    );
  }

  setDone() {
    this._done = true;
  }

  private static DONE_KEY = '__init__';
}
